import { deserialize, serialize } from "serializr";
import axiosInstance from "../../../interceptor/axiosInstance";
import { ContentLibraryModel } from "../../../models/ContentLibraryModel/contentLibrary.model";
import { ExamContentModel, UpdateExamContentModel } from "../../../models/ExamModels/ContentModel/content.model";
import {
  EXAM_SUBJECT_CHAPTERS_CONTENTS_LIST,
  EXAM_SUBJECT_CHAPTER_EXERCISES_LIST,
} from "../../../routes/routeConstants/apiRoutes";

export class ExamContentService {
  static fetchExamContents(
    queryParams: any,
    onSuccess: Function,
    onError: Function
  ) {
    return axiosInstance
      .get(EXAM_SUBJECT_CHAPTERS_CONTENTS_LIST, {
        params: queryParams,
      })
      .then((response) => {
        const contents = deserialize(
          ExamContentModel,
          response.data["exam_chapter_contents"]
        );
        onSuccess(contents);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static updateExamContent(
    data: any,
    onSuccess:Function,
    onError: Function
  ){
    const serializeContent = serialize(UpdateExamContentModel, data["contentData"])
    const payload  = { exam_chapter_content : serializeContent}
    return axiosInstance
    .put(EXAM_SUBJECT_CHAPTERS_CONTENTS_LIST + `/${data.id}`, payload)
    .then(() => {
      onSuccess()
    })
    .catch(error => {
      onError(error)
    })
  }
  static deleteExamContent (
    id: number,
    onSuccess: Function,
    onError:Function
  ) {
    return axiosInstance
    .delete(EXAM_SUBJECT_CHAPTERS_CONTENTS_LIST + `/${id}`)
    .then(response => {
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
  }
  static createNewExamContent (
    data: any,
    onSuccess: Function,
    onError: Function
  ) {

    const serializeContent = serialize(UpdateExamContentModel, data)
    const payload = {exam_chapter_contents: serializeContent}

    console.log(payload)
    return axiosInstance
    .post(EXAM_SUBJECT_CHAPTERS_CONTENTS_LIST + "/bulk", payload)
    .then(response => {
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
  }
}
